"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function domIsOverflow() {
    return window.innerWidth > document.body.clientWidth;
}
exports.default = domIsOverflow;
//# sourceMappingURL=domIsOverFlow.js.map